// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"0c989746","43":"3727b762","98":"411ef295","127":"ffb7dad1","381":"e1fc888c","892":"820c5f78","915":"493075b3","950":"37a6255e","987":"6ad50e58"}[chunkId] + ".chunk.js";
};